<template>
  <PrintPageLandscape
    :page-number="pageNumber"
    :page-count="pageCount"
    :background-image-url="'/img/short_teaser/short_teaser_start_bg.png'"
  >
    <template #header>
      <div class="short-teaser-start__header">
        <div class="short-teaser-start__logoLink">
          <img
            v-if="clientLogoPath"
            class="short-teaser-start__logoImage"
            :src="clientLogoPath"
            :alt="clientLogoAlt"
          />
        </div>
      </div>
    </template>

    <div v-if="project" class="short-teaser-start__main" :data-project-number="project.number">
      <div class="short-teaser-start__card">
        <h1 class="short-teaser-start__customerName">
          {{ this.project.employerProjectNumber }}
        </h1>
        <p class="short-teaser-start__projectCaption">
          {{ $t('shortTeaserPrintCoverProjectLabel', { number: project.number }) }}
        </p>
      </div>
    </div>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import { getClientLogoPath } from '@/helpers/clientLogo';

export default {
  name: 'ShortTeaserPrintPage1',

  components: {
    PrintPageLandscape,
  },

  props: {
    project: {
      type: Object,
      default: null,
    },
    pageCount: {
      type: Number,
      default: null,
    },
    pageNumber: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    client() {
      if (!this.project || !this.project.client) {
        return null;
      }
      return this.project.client;
    },
    clientLogoPath() {
      return getClientLogoPath(this.client);
    },
    clientLogoAlt() {
      if (this.client && this.client.name) {
        return this.client.name;
      }
      return this.$t('shortTeaserPrintLogoAlt');
    },
  },
};
</script>
